import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type Patient from 'parog-web/models/patient';

export default <template>
  <div class='six wide field'>
    <@form.Date @labelName='Date du diagnostic' @propertyName='diagnosisDate' />
  </div>
  {{#unless @patient.healthCentre.lgcEnabled}}
    <div class='field'>
      <@form.Dropdown
        @labelName='Activité de la maladie'
        @propertyName='diseaseActivity'
        @translationKey='medical-history-changed-journal-event.disease-activity'
        as |dropdown|
      >
        <dropdown.Item @key='inactive' />
        <dropdown.Item @key='weak' />
        <dropdown.Item @key='moderate' />
        <dropdown.Item @key='severe' />

      </@form.Dropdown>
    </div>
  {{/unless}}
  <div class='field'>
    <@form.Dropdown
      @labelName='Age au diagnostic'
      @propertyName='diagnosticAge'
      @translationKey='medical-history-changed-journal-event.diagnostic-age'
      as |dropdown|
    >
      <dropdown.Item @key='lt_17' />
      <dropdown.Item @key='between_17_40' />
      <dropdown.Item @key='gt_40' />
    </@form.Dropdown>
  </div>

  <div class='field'>
    <@form.Dropdown
      @labelName='Topographie'
      @propertyName='localisation'
      @translationKey='medical-history-changed-journal-event.localisation'
      as |dropdown|
    >
      <dropdown.Item @key='l1' />
      <dropdown.Item @key='l2' />
      <dropdown.Item @key='l3' />
      <dropdown.Item @key='l4' />
    </@form.Dropdown>
  </div>

  <div class='field'>
    <@form.Dropdown
      @labelName='Phénotype'
      @propertyName='evolution'
      @translationKey='medical-history-changed-journal-event.evolution'
      as |dropdown|
    >
      <dropdown.Item @key='b1' />
      <dropdown.Item @key='b2' />
      <dropdown.Item @key='b3' />
      <dropdown.Item @key='p' />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient: Patient;
  };
}>;
